export default {
    favoriteVendors: null,
    favoriteProducts: null,
};
